import { cx } from "@emotion/css";
import { useState } from "react";
import { ChangeEventHandler, forwardRef, ReactNode } from "react";

import { useTheme } from "@/modules/theme/hooks/useTheme";

import {
  InputErrorMessage,
  InputErrorMessageProps,
} from "../ErrorMessage/InputErrorMessage";
import { InputError } from "../InputError/InputError";

import { createRadioStyles } from "./helpers/createRadioStyles";

interface RadioProps extends InputErrorMessageProps {
  className?: string;
  labelClassName?: string;
  name: string;
  id: string;
  onChange?: ChangeEventHandler<HTMLInputElement>;
  value: string | number;
  label: ReactNode;
  error?: string;
  description?: string;
  hideError?: boolean;
  checked?: boolean;
  defaultChacked?: boolean;
}

export const Radio = forwardRef<HTMLInputElement, RadioProps>(
  (
    {
      name,
      id,
      onChange,
      value,
      className,
      labelClassName,
      label,
      description,
      hideError = false,
      checked,
      defaultChacked,
      error,
      errorMessages,
      ErrorMessage,
    },
    ref
  ) => {
    const theme = useTheme();
    const classes = createRadioStyles(theme);
    const [appliedError, setAppliedError] = useState("");

    const handleErrorChange = (error: string) => {
      setAppliedError(error);
    };

    return (
      <div className={cx(classes.root, className)}>
        <input
          type="radio"
          className={classes.radio}
          name={name}
          ref={ref}
          id={id}
          value={value}
          onChange={onChange}
          checked={checked}
          defaultChecked={defaultChacked}
        />
        <label
          className={cx(
            classes.label,
            {
              [classes.errorLabel]: Boolean(appliedError),
            },
            labelClassName
          )}
          htmlFor={id}
        >
          {label}
        </label>
        {description && (
          <span className={classes.description}>{description}</span>
        )}
        <InputError className={cx({ [classes.errorHidden]: hideError })}>
          <InputErrorMessage
            error={error}
            errorMessages={errorMessages}
            ErrorMessage={ErrorMessage}
            name={name}
            onErrorChange={handleErrorChange}
          />
        </InputError>
      </div>
    );
  }
);
